import { memo } from 'react';
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTextField from 'components/ui/form/FormTextField';
import FormFileUploadField from 'components/ui/form/FormFileUploadField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  file: yup.mixed().nullable().required('tasks.staffTask.validation.file'),
});

const TaskFileModal = ({ open, setOpen, taskId, refetchFn }) => {
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: { file: null, title: '' },
    validationSchema,
    onSubmit: (values) => {
      submit(
        { type: 'post', contentType: 'formData' },
        values,
        `/admin/task-staff/addfile/${taskId}`,
        { title: t('tasks.staffTask.alerts.fileUploaded') },
        null,
        true,
        handleFinish
      );
    },
  });

  const handleFinish = () => {
    refetchFn();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{ className: '!base-border !shadow-none' }}
      disableEscapeKeyDown
    >
      <DialogTitle className='!bg-gray-100 !mb-2 text-center'>
        {t('tasks.staffTask.fileModal.title')}
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit} className='pt-2'>
          <Grid container spacing={2} rowSpacing={1} columns={{ xs: 12 }}>
            <Grid item xs={12}>
              <FormTextField
                delay={0}
                label={t('common.fields.simpleName')}
                fieldName='title'
                formik={formik}
              />
            </Grid>

            <Grid item xs={12}>
              <FormFileUploadField
                delay={0.1}
                accept='.doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.gif,.bmp'
                fieldName='file'
                formik={formik}
                label={t('common.fields.uploadFile')}
                btnLabel={t('common.fields.uploadFile')}
                fileSize={10}
              />
            </Grid>

            <Grid item xs={12}>
              <FormActionButtons
                delay={0.2}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(TaskFileModal);
